export const UPDATE_AUTH="UPDATE_AUTH"
